import { apiRequest } from '../../../api/client';
import type { UserRead, VoiceTranscriptionResponse } from '../../../api/types';
import { audioFileName } from '../lib/audioMime';

// PARA-132 — только HTTP: интерпретация ответов живёт в lib/voiceErrors.ts.
// Оба запроса помечены allowForbidden (AD-1): 403 здесь — штатный бизнес-ответ
// (тариф ниже Ultimate / согласие не дано), а не потеря доступа.

export async function transcribeVoice(
  audio: Blob,
  mimeType: string,
): Promise<VoiceTranscriptionResponse> {
  // B-1: имя поля формы — 'audio'; Content-Type с boundary ставит браузер.
  const formData = new FormData();
  formData.append('audio', audio, audioFileName(mimeType));

  return apiRequest<VoiceTranscriptionResponse>('/tasks/voice-transcriptions', {
    method: 'POST',
    body: formData,
    allowForbidden: true,
  });
}

/** B-13: grant-only, без тела запроса; ответ — обновлённый профиль. */
export async function grantVoiceConsent(): Promise<UserRead> {
  return apiRequest<UserRead>('/users/me/voice-consent', {
    method: 'POST',
    allowForbidden: true,
  });
}
